import Vue from 'vue';
import {
  LIST
} from './mutation-types';

export default {

  [LIST](state, items) {
    state.items  = items;
  },


};
